const metricStore = {
  namespaced: true,
  state: () => ({
    metrics: [], // Hold the values of selected items [{objectType: item.objectType,value: value,text: item.metricName}],
    justReset: 0,
    errorMessage: '',
    messageErrorMaxSelectState: ''
  }),
  getters: {},
  mutations: {
    addMetric: (state, metric) => {
      state.metrics.push(metric);
      state.metrics.sort((a, b) => a.orderInFlatMetrics - b.orderInFlatMetrics);
    },
    removeMetric: (state, index) => state.metrics.splice(index, 1),
    resetMetric: (state, ignoreChange = false) => {
      state.metrics = [];
      if (!ignoreChange) state.justReset = Date.now();
    },
    setMetric: (state, metrics) => {
      state.metrics = [...metrics];
    },
    setErrorMessage: (state, message) => {
      state.errorMessage = message;
    },
    setMessageErrorMaxSelect: (state, message) => {
      state.messageErrorMaxSelectState = message;
    }
  },
  actions: {
    syncSelectMetric: ({ commit, state }, metric) => {
      const index = state.metrics.findIndex(
        (i) => i.metricKey === metric.metricKey && i.objectType === metric.objectType
      );

      if (index > -1 && !metric.check) {
        commit('removeMetric', index);
      } else if (index === -1 && metric.check) {
        commit('addMetric', metric);
      }
    },
    resetSelectMetric: ({ commit }, ignoreChange = false) => commit('resetMetric', ignoreChange),
    selectMetricAction: ({ commit }, metrics) => commit('setMetric', metrics),
    setErrorMessage: ({ commit }, message) => commit('setErrorMessage', message),
    setMessageForMaxSelect: ({ commit }, message) => commit('setMessageErrorMaxSelect', message)
  }
};

export default metricStore;
